import React from 'react';
import { Dropdown } from '@trevor/ui-components';
import { SavedQueryButton } from './SavedQueryButton';
import { DropdownContent } from './DropdownContent';

export const StartFromSavedQueryDropdown: React.FC = () => (
  <Dropdown>
    <Dropdown.Trigger>
      <SavedQueryButton>Saved query</SavedQueryButton>
    </Dropdown.Trigger>
    <DropdownContent />
  </Dropdown>
);
